import { Context } from "@/App";
import Card from "@/base-components/Card";
import useModel from "@/base-components/hooks/useModel";
import Table, { TableProps } from "@/base-components/Table";
import { RoutePath } from "@/generic/config";
import { Customer } from "@/model/customer";
import { WorksiteHitWithoutCustomer } from "@/model/worksite";
import React from "react";

const CustomerWorksites = ({ model }: { model: ReturnType<typeof useModel<Customer>>["model"] }) => {
    const { translations } = React.useContext(Context);

    const tableProps: TableProps<WorksiteHitWithoutCustomer> = {
        columns: [
            { title: translations.model.worksite.id, scale: 1, getter: (r) => r.id },
            { title: translations.model.worksite.externalId, scale: 1, getter: (r) => r.externalId ?? "" },
            { title: translations.model.worksite.city, scale: 2, getter: (r) => r.city },
            { title: translations.model.worksite.postalCode, scale: 1, getter: (r) => r.postalCode },
            { title: translations.model.worksite.address, scale: 3, getter: (r) => r.address },
        ],
        rows: model.object.worksites,
        href: (row) => `${RoutePath.Worksites}/${row.id}`,
    };

    return (
        <Card {...translations.model.customer.cards.worksites}>
            <Table tableProps={tableProps} />
        </Card>
    )
}

export default CustomerWorksites;